import * as moment from 'moment';

export class DateMoment {
  startDate: moment.Moment | any;
  endDate: moment.Moment | any;
}